<template>
    <div v-if="show" style="color:red;">
        温馨提醒：为正确显示本网站，请使用
        <span><a href="http://browser.qq.com/" target="_blank" style="color:red;">QQ浏览器(极速模式)、</a> </span>
        <span><a href="http://browser.360.cn/" target="_blank" style="color:red;">360浏览器(极速模式)、</a> </span>
        <span><a href="https://www.google.cn/chrome/browser/desktop/index.html" style="color:red;" target="_blank">谷歌浏览器、</a>
        <span><a style="color:red;" href="https://support.microsoft.com/zh-cn/topic/%E4%B8%8B%E8%BD%BD-internet-explorer-11-%E8%84%B1%E6%9C%BA%E5%AE%89%E8%A3%85%E7%A8%8B%E5%BA%8F-99d492a1-3a62-077b-c476-cf028aff9a7f" target="_blank">微软IE 11、</a> </span>
        <span><a style="color:red;" href="https://www.microsoft.com/zh-cn/edge" target="_blank">微软Edge、</a> </span>
        <span><a style="color:red;" href="http://www.firefox.com.cn/" target="_blank">火狐浏览器 </a></span>
        </span>
    </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    props: {},
    data () {
      return {
        show: false
      }
    },
    created () {
      this.showbox()
    },
    computed: {
      ...mapState({})
    },
    methods: {
      handleClose () {

      },
      myBrowser () {
        var userAgent = navigator.userAgent
        var isOpera = userAgent.indexOf('Opera') > -1
        var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera
        if (isIE) {
          var IE55 = false
          var IE6 = false
          var IE7 = false
          var IE8 = false
          var IE9 = false
          var IE10 = false
          var reIE = new RegExp('MSIE (\\d+\\.\\d+)')
          reIE.test(userAgent)
          var fIEVersion = parseFloat(RegExp['$1'])
          IE55 = fIEVersion == 5.5  //eslint-disable-line
          IE6 = fIEVersion == 6.0  //eslint-disable-line
          IE7 = fIEVersion == 7.0  //eslint-disable-line
          IE8 = fIEVersion == 8.0  //eslint-disable-line
          IE9 = fIEVersion == 9  //eslint-disable-line
          IE10 = fIEVersion == 10  //eslint-disable-line
          if (IE55) {
            return 'IE55'
          }
          if (IE6) {
            return 'IE6'
          }
          if (IE7) {
            return 'IE7'
          }
          if (IE8) {
            return 'IE8'
          }
          if (IE9) {
            return 'IE9'
          }
          if (IE10) {
            return 'IE10'
          }
        }
      },
      showbox () {
        if (this.myBrowser() == 'IE55') { //eslint-disable-line
          this.show = true
        }
        if (this.myBrowser() == 'IE6') { //eslint-disable-line
          this.show = true
        }
        if (this.myBrowser() == 'IE7') { //eslint-disable-line
          this.show = true
        }
        if (this.myBrowser() == 'IE8') { //eslint-disable-line
          this.show = true
        }
        if (this.myBrowser() == 'IE9') { //eslint-disable-line
          this.show = true
        }
        if (this.myBrowser() == 'IE10') { //eslint-disable-line
          this.show = true
        }
      }
    }
  }
</script>

<style scoped>
.box{
    z-index: 999999
}
</style>



// WEBPACK FOOTER //
// versionReminder.vue?b330d87e